import styled from 'styled-components';

export const CounterContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin-bottom: 15px;

    @media (max-width: 600px) {
        gap: 5px;
        margin-bottom: 8px;
    }
`;

export const CounterBadge = styled.div`
    background: ${props =>
        props.veryLow ? 'rgba(200, 50, 50, 0.2)' :
        props.low ? 'rgba(247, 144, 0, 0.2)' :
        'rgba(100, 200, 100, 0.2)'
    };
    border: 2px solid ${props =>
        props.veryLow ? 'rgba(200, 50, 50, 0.5)' :
        props.low ? 'rgba(247, 144, 0, 0.5)' :
        'rgba(100, 200, 100, 0.5)'
    };
    border-radius: 12px;
    padding: 10px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    transition: all 0.3s;

    &:hover {
        transform: scale(1.02);
    }

    /* Mobile: tudo em uma linha só, mais compacto */
    @media (max-width: 600px) {
        flex-direction: row;
        gap: 6px;
        padding: 5px 12px;
        border-width: 1px;
        border-radius: 16px;
    }
`;

export const CounterText = styled.span`
    color: #ccc;
    font-size: 13px;
    font-weight: 500;

    @media (max-width: 600px) {
        font-size: 12px;
    }
`;

export const CounterNumber = styled.span`
    color: ${props =>
        props.veryLow ? '#ff6b6b' :
        props.low ? 'rgb(247, 144, 0)' :
        '#4caf50'
    };
    font-size: 20px;
    font-weight: bold;

    /* Mobile: fonte do mesmo tamanho do texto, para caber na linha */
    @media (max-width: 600px) {
        font-size: 12px;
    }
`;

export const UpgradeLink = styled.button`
    background: transparent;
    border: none;
    color: rgb(247, 144, 0);
    font-size: 13px;
    cursor: pointer;
    text-decoration: underline;
    transition: all 0.2s;

    &:hover {
        color: rgb(220, 120, 0);
        transform: scale(1.05);
    }
`;
